import React, { FC } from "react";
import { CloseDayList } from "../../components";

export const CloseDayPage: FC = () => {
  return <CloseDayList />;
};
